// 배포 뒤 열어 둔 탭에서 화면 파일을 못 받으면 가려던 주소를 새로 불러온다.
//
// 화면(라우트)은 누를 때 따로 받아 온다(() => import()). 파일 이름에 해시가 붙어 있고, 배포하면
// 새 컨테이너에는 새 판 파일만 있다 — 옛 판 파일은 어디에도 남지 않는다. 그래서 배포 전에 열어
// 둔 탭에서 메뉴를 누르면 옛 판 화면 파일이 404 가 나고 화면이 바뀌지 않는다(2026-11-05 확인:
// 14:15 판 스크립트가 14:58 배포 뒤 404). 가려던 주소를 통째로 다시 열면 새 index.html 이 새 판
// 파일을 가리키므로 그다음부터는 정상이다.
//
// 배포 중 1분 동안 두 판이 같이 서 있는 문제는 여기서 다루지 않는다. 그쪽은 ALB 스티키 쿠키가
// 막는다(goldnara-infra 05-platform.yaml 의 클라이언트 타깃그룹).
//
// 새로 불러온 뒤에도 또 실패하면(배포가 깨졌거나 파일이 정말 없다) 30초 안에는 다시 하지 않고
// 원래 오류를 그대로 둔다 — 무한 새로고침을 막는다.
//
// 세 저장소(homepage · goldnaramall-client · mediahub-client)에 같은 파일로 둔다.

const KEY = 'stale-chunk-reload-at'
const WINDOW_MS = 30_000

// 브라우저마다 문구가 다르다 — 크롬 · 파이어폭스 · 사파리, 그리고 Vite 의 CSS 미리 받기.
const STALE_CHUNK =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i

const mayReload = () => {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0)
    if (Date.now() - last < WINDOW_MS) return false
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch {
    // 저장소가 막혀 있으면(사생활 보호 창 등) 한 번 시도는 한다
  }
  return true
}

export function reloadOnStaleChunk(router) {
  router.onError((error, to) => {
    if (!STALE_CHUNK.test(String(error?.message || ''))) return
    if (!mayReload()) return
    window.location.assign(to ? router.resolve(to.fullPath).href : window.location.href)
  })
}
